import { MissingConsentForm } from '@hb/shared'
import { createContext, FC, ReactNode, useContext, useState } from 'react'

interface MissingFormsContextType {
  missingForms: MissingConsentForm[]
  setMissingForms: (forms: MissingConsentForm[]) => void
}

const MissingFormsContext = createContext<MissingFormsContextType | undefined>(undefined)

export const MissingFormsProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [missingForms, setMissingForms] = useState<MissingConsentForm[]>([])

  return (
    <MissingFormsContext.Provider value={{ missingForms, setMissingForms }}>
      {children}
    </MissingFormsContext.Provider>
  )
}

export const useMissingForms = () => {
  const context = useContext(MissingFormsContext)
  if (context === undefined) {
    throw new Error('useMissingForms must be used within a MissingFormsProvider')
  }
  return context
}
